import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

const FALLBACK_HOTEL_IMAGE = 'assets/images/hotel.png';

function HotelList({ hotels, onHotelShowMapClick, onHotelFilter, onHotelClick }) {
  const [hotelList, setHotelList] = useState(hotels);
  const [search, setSearch] = useState('');
  const { t } = useTranslation('hotel');

  useEffect(() => {
    setHotelList(hotels);
  }, [hotels])

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    onHotelFilter(e.target.value);
  }

  return (
    <>
      <div className='hotel-list'>
        <div className='hotel-list-header'>
          <h3>{t('partner_hotels')}</h3>
          <div className='search'>
            <input type='text' placeholder={t('search')} value={search} onChange={handleSearchChange} />
            <img src='/assets/images/icon-search.svg' alt='search' />
          </div>
        </div>
        {hotelList.length > 0 && (
          <ul className='hotel-items'>
            {hotelList.map((hotel) => (<li className='hotel-item' key={hotel.id} onClick={() => onHotelClick(hotel)}>
              <img
                className='hotel-image'
                src={hotel.media?.length ? hotel.media[0].original_url : FALLBACK_HOTEL_IMAGE}
                alt='hotel_image'
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = FALLBACK_HOTEL_IMAGE;
                }}
              />
              <div className='hotel-details'>
                <span className='badge-duo'>
                  {hotel.duo_capability ? (
                    <>
                      <img
                        src='assets/images/icon-checked.svg'
                        alt='star icon'
                        style={{ verticalAlign: 'middle', marginRight: '4px' }}
                      />
                      DUO
                    </>
                  ) : (
                    'NO DUO'
                  )}
                </span>
                <span className='hotel-name'>{hotel.name}</span>
                <span className='hotel-rating'>
                  <img src="/assets/images/icon-stars.svg" alt='star icon' height={13.5} width={13.5} />
                  {hotel?.extra?.google_rating?.rating ? (
                    `${Number(hotel.extra.google_rating.rating).toFixed(1)}/5 ${hotel.extra.google_rating.user_ratings_total ? `(${hotel.extra.google_rating.user_ratings_total})` : ''}`
                  ) : hotel?.extra?.rating ? (
                    `${hotel.extra.rating}/5`
                  ) : (
                    '—'
                  )}
                </span>
                <span className='hotel-distance'>{t('distance_from_city_center', { distance: hotel.distance_from_center })}</span>
                <button className='show-map' onClick={(e) => { e.stopPropagation(); onHotelShowMapClick(hotel) }}><img src='/assets/images/icon-map.svg' />{t('show_on_map')}</button>
              </div>
            </li>
            ))}
          </ul>
        )}
      </div >
    </>
  );
}

export default HotelList;
